/**
 * Admin allowlist
 *
 * The platform has a single admin account. This is the client-side copy of
 * the allowlist; the authoritative checks live in firestore.rules and the
 * admin Cloud Functions. Keep all three in sync.
 */

export const ADMIN_EMAIL = 'joseph.hamawi.ng@gmail.com';
